/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountSync {
    getFixupPrototypeFunction() { return ServiceAccountSync.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountSync>): ServiceAccountSync {
        let obj = Object.assign(new ServiceAccountSync(), model);
        ServiceAccountSync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountSync>): ServiceAccountSync {
        if (!model) return null;
        return ServiceAccountSync.newInstance(<ServiceAccountSync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountSync) {
        if (!obj) return;

        models.ServiceAccountSync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountSync): boolean {
        Object.setPrototypeOf(obj, ServiceAccountSync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.access_governance) {
            models.ProgressDetails.fixupPrototype(this.access_governance);
        }
        if (this.access_validation) {
            models.ProgressDetailsForAccessValidation.fixupPrototype(this.access_validation);
        }
        if (this.advisor_data) {
            models.ProgressDetails.fixupPrototype(this.advisor_data);
        }
        if (this.application_performance_data) {
            models.ProgressDetails.fixupPrototype(this.application_performance_data);
        }
        if (this.aws_compute_optimizer_data) {
            models.ProgressDetails.fixupPrototype(this.aws_compute_optimizer_data);
        }
        if (this.aws_security_hub) {
            models.ProgressDetailsForSecurityHub.fixupPrototype(this.aws_security_hub);
        }
        if (this.azure_ea_unit_price) {
            models.ProgressDetailsForEaUnitRate.fixupPrototype(this.azure_ea_unit_price);
        }
        if (this.azure_hub_discount) {
            models.ProgressDetails.fixupPrototype(this.azure_hub_discount);
        }
        if (this.azure_recommendations_data) {
            models.ProgressDetails.fixupPrototype(this.azure_recommendations_data);
        }
        if (this.billing_info) {
            models.ProgressDetailsForCostProcessing.fixupPrototype(this.billing_info);
        }
        if (this.cloud_account_tag) {
            models.ProgressDetails.fixupPrototype(this.cloud_account_tag);
        }
        if (this.cloudops__activity_assessment) {
            models.ProgressDetails.fixupPrototype(this.cloudops__activity_assessment);
        }
        if (this.cloudops__ai_prompt_analytics) {
            models.ProgressDetailsForAiPromptAnalytics.fixupPrototype(this.cloudops__ai_prompt_analytics);
        }
        if (this.cloudops__ai_telemetry) {
            models.ProgressDetails.fixupPrototype(this.cloudops__ai_telemetry);
        }
        if (this.cloudops__backup) {
            models.ProgressDetailsForBackupData.fixupPrototype(this.cloudops__backup);
        }
        if (this.cloudops__bigquery_metric) {
            models.ProgressDetails.fixupPrototype(this.cloudops__bigquery_metric);
        }
        if (this.cloudops__custom_metric) {
            models.ProgressDetails.fixupPrototype(this.cloudops__custom_metric);
        }
        if (this.cloudops__log_analytics_query) {
            models.ProgressDetails.fixupPrototype(this.cloudops__log_analytics_query);
        }
        if (this.cloudops__metric) {
            models.ProgressDetailsForMetricData.fixupPrototype(this.cloudops__metric);
        }
        if (this.cloudops__monitoring_alert_assessment) {
            models.ProgressDetails.fixupPrototype(this.cloudops__monitoring_alert_assessment);
        }
        if (this.cloudops__patch_management) {
            models.ProgressDetails.fixupPrototype(this.cloudops__patch_management);
        }
        if (this.cloudops__ssm) {
            models.ProgressDetailsForSsmData.fixupPrototype(this.cloudops__ssm);
        }
        if (this.credential_validation) {
            models.ProgressDetailsForCredentialsValidation.fixupPrototype(this.credential_validation);
        }
        if (this.dimension_precompute) {
            models.ProgressDetailsForDimensionPrecompute.fixupPrototype(this.dimension_precompute);
        }
        if (this.dimension_precompute_for_ai) {
            models.ProgressDetailsForDimensionPrecompute.fixupPrototype(this.dimension_precompute_for_ai);
        }
        if (this.daily_cost_report) {
            models.ProgressDetails.fixupPrototype(this.daily_cost_report);
        }
        if (this.finops__ai_caller_attribution) {
            models.ProgressDetailsForAiBilling.fixupPrototype(this.finops__ai_caller_attribution);
        }
        if (this.finops__assessment_report) {
            models.ProgressDetails.fixupPrototype(this.finops__assessment_report);
        }
        if (this.finops__budget_data) {
            models.ProgressDetails.fixupPrototype(this.finops__budget_data);
        }
        if (this.finops__cost_anomaly) {
            models.ProgressDetails.fixupPrototype(this.finops__cost_anomaly);
        }
        if (this.finops__cost_savings) {
            models.ProgressDetails.fixupPrototype(this.finops__cost_savings);
        }
        if (this.finops__crp_recommendation) {
            models.ProgressDetails.fixupPrototype(this.finops__crp_recommendation);
        }
        if (this.finops__enterprise_discount_program) {
            models.ProgressDetails.fixupPrototype(this.finops__enterprise_discount_program);
        }
        if (this.finops__recommendation_v2) {
            models.ProgressDetails.fixupPrototype(this.finops__recommendation_v2);
        }
        if (this.finops__ri_ontology_sync) {
            models.ProgressDetails.fixupPrototype(this.finops__ri_ontology_sync);
        }
        if (this.finops__savings_plans) {
            models.ProgressDetailsForSavingsPlans.fixupPrototype(this.finops__savings_plans);
        }
        if (this.finops__schedule_recommendation) {
            models.ProgressDetails.fixupPrototype(this.finops__schedule_recommendation);
        }
        if (this.finops__sp_ontology_sync) {
            models.ProgressDetails.fixupPrototype(this.finops__sp_ontology_sync);
        }
        if (this.gcp_security_command_center) {
            models.ProgressDetails.fixupPrototype(this.gcp_security_command_center);
        }
        if (this.governance_configuration) {
            models.ProgressDetailsForGovernanceConfiguration.fixupPrototype(this.governance_configuration);
        }
        if (this.governance_configuration_validation) {
            models.ProgressDetailsForGovernanceConfiguration.fixupPrototype(this.governance_configuration_validation);
        }
        if (this.governance_report) {
            models.ProgressDetails.fixupPrototype(this.governance_report);
        }
        if (this.hierarchy_data) {
            models.ProgressDetails.fixupPrototype(this.hierarchy_data);
        }
        if (this.inventory_data) {
            models.ProgressDetails.fixupPrototype(this.inventory_data);
        }
        if (this.inventory_data__dashboard_sync) {
            models.ProgressDetails.fixupPrototype(this.inventory_data__dashboard_sync);
        }
        if (this.inventory_data__dependency_sync) {
            models.ProgressDetails.fixupPrototype(this.inventory_data__dependency_sync);
        }
        if (this.inventory_data__lock_sync) {
            models.ProgressDetails.fixupPrototype(this.inventory_data__lock_sync);
        }
        if (this.inventory_data__relationship_sync) {
            models.ProgressDetails.fixupPrototype(this.inventory_data__relationship_sync);
        }
        if (this.inventory_report) {
            models.ProgressDetails.fixupPrototype(this.inventory_report);
        }
        if (this.kubernetes_cluster_agent_sync_job) {
            models.ProgressDetailsForKubernetesAgentSyncStatus.fixupPrototype(this.kubernetes_cluster_agent_sync_job);
        }
        if (this.kubernetes_cluster_agent_health) {
            models.ProgressDetails.fixupPrototype(this.kubernetes_cluster_agent_health);
        }
        if (this.metric_utilization_data) {
            models.ProgressDetails.fixupPrototype(this.metric_utilization_data);
        }
        if (this.monthly_cost_report) {
            models.ProgressDetails.fixupPrototype(this.monthly_cost_report);
        }
        if (this.network_data) {
            models.ProgressDetails.fixupPrototype(this.network_data);
        }
        if (this.proactive_scanner) {
            models.ProgressDetails.fixupPrototype(this.proactive_scanner);
        }
        if (this.recovery_data) {
            models.ProgressDetails.fixupPrototype(this.recovery_data);
        }
        if (this.reserved_instances_recommendation) {
            models.ProgressDetailsForReservedInstances.fixupPrototype(this.reserved_instances_recommendation);
        }
        if (this.reserved_instances_utilization) {
            models.ProgressDetailsForReservedInstances.fixupPrototype(this.reserved_instances_utilization);
        }
        if (this.secure_score_data) {
            models.ProgressDetailsForSecureScore.fixupPrototype(this.secure_score_data);
        }
        if (this.security__azure_sentinel) {
            models.ProgressDetails.fixupPrototype(this.security__azure_sentinel);
        }
        if (this.security__tenable_nessus) {
            models.ProgressDetails.fixupPrototype(this.security__tenable_nessus);
        }
        if (this.servicenow_cmdb_sync_job) {
            models.ProgressDetailsForServiceNowCmdbSync.fixupPrototype(this.servicenow_cmdb_sync_job);
        }
        if (this.system_policy_execution) {
            models.ProgressDetails.fixupPrototype(this.system_policy_execution);
        }
        if (this.threat_data) {
            models.ProgressDetailsForThreat.fixupPrototype(this.threat_data);
        }
        if (this.utilization_metrics_data) {
            models.ProgressDetails.fixupPrototype(this.utilization_metrics_data);
        }
        if (this.vulnerability_data) {
            models.ProgressDetailsForVulnerability.fixupPrototype(this.vulnerability_data);
        }
        if (this.wellarchitected__auto_assessment) {
            models.ProgressDetailsForWellArchitectedAutoAssessment.fixupPrototype(this.wellarchitected__auto_assessment);
        }
    }

    /**
     * Access Governance current status
     */
    access_governance: models.ProgressDetails;

    /**
     * Access Validation current status
     */
    access_validation: models.ProgressDetailsForAccessValidation;

    /**
     * Advisor Data current status
     */
    advisor_data: models.ProgressDetails;

    /**
     * Application Performance data current status
     */
    application_performance_data: models.ProgressDetails;

    /**
     * AWS Compute Optimizer Data current status
     */
    aws_compute_optimizer_data: models.ProgressDetails;

    /**
     * AWS Security Hub Sync Details current status
     */
    aws_security_hub: models.ProgressDetailsForSecurityHub;

    /**
     * Azure EA Unit Price Data current status
     */
    azure_ea_unit_price: models.ProgressDetailsForEaUnitRate;

    /**
     * Azure Hub Discount Details current status
     */
    azure_hub_discount: models.ProgressDetails;

    /**
     * Azure Recommendations Data current status
     */
    azure_recommendations_data: models.ProgressDetails;

    /**
     * Billing Info current status
     */
    billing_info: models.ProgressDetailsForCostProcessing;

    /**
     * Cloud Account Tag Sync current status
     */
    cloud_account_tag: models.ProgressDetails;

    /**
     * Activity Assessment Data current status
     */
    cloudops__activity_assessment: models.ProgressDetails;

    /**
     * AI Prompt Analytics current status
     */
    cloudops__ai_prompt_analytics: models.ProgressDetailsForAiPromptAnalytics;

    /**
     * AI Telemetry current status
     */
    cloudops__ai_telemetry: models.ProgressDetails;

    /**
     * Backup Data current status
     */
    cloudops__backup: models.ProgressDetailsForBackupData;

    /**
     * BigQuery Metric Data current status
     */
    cloudops__bigquery_metric: models.ProgressDetails;

    /**
     * Custom Metric Data current status
     */
    cloudops__custom_metric: models.ProgressDetails;

    /**
     * Log Analytics Query Data current status
     */
    cloudops__log_analytics_query: models.ProgressDetails;

    /**
     * Metric Data current status
     */
    cloudops__metric: models.ProgressDetailsForMetricData;

    /**
     * Monitoring Alert Assessment Data current status
     */
    cloudops__monitoring_alert_assessment: models.ProgressDetails;

    /**
     * Patch Management Data current status
     */
    cloudops__patch_management: models.ProgressDetails;

    /**
     * SSM Data current status
     */
    cloudops__ssm: models.ProgressDetailsForSsmData;

    /**
     * Credential Check Info current status
     */
    credential_validation: models.ProgressDetailsForCredentialsValidation;

    /**
     * Dimension Precompute current status
     */
    dimension_precompute: models.ProgressDetailsForDimensionPrecompute;

    /**
     * Dimension Precompute for AI current status
     */
    dimension_precompute_for_ai: models.ProgressDetailsForDimensionPrecompute;

    /**
     * Daily Cost Report current status
     */
    daily_cost_report: models.ProgressDetails;

    /**
     * AI Caller Attribution current status
     */
    finops__ai_caller_attribution: models.ProgressDetailsForAiBilling;

    /**
     * Finops Assessment Report current status
     */
    finops__assessment_report: models.ProgressDetails;

    /**
     * Budget Data current status
     */
    finops__budget_data: models.ProgressDetails;

    /**
     * Cost Anomaly current status
     */
    finops__cost_anomaly: models.ProgressDetails;

    /**
     * Schedule Recommendation Cost Savings current status
     */
    finops__cost_savings: models.ProgressDetails;

    /**
     * CRP Recommendation current status
     */
    finops__crp_recommendation: models.ProgressDetails;

    /**
     * Enterprise Discount Program current status
     */
    finops__enterprise_discount_program: models.ProgressDetails;

    /**
     * Finops Recommendations V2 current status
     */
    finops__recommendation_v2: models.ProgressDetails;

    /**
     * Billing & Cost Analytics — RI ontology projection into GraphDB current status
     */
    finops__ri_ontology_sync: models.ProgressDetails;

    /**
     * Savings Plans current status
     */
    finops__savings_plans: models.ProgressDetailsForSavingsPlans;

    /**
     * Schedule Recommendation current status
     */
    finops__schedule_recommendation: models.ProgressDetails;

    /**
     * Billing & Cost Analytics — SP ontology projection into GraphDB current status
     */
    finops__sp_ontology_sync: models.ProgressDetails;

    /**
     * GCP Security Command Center Data current status
     */
    gcp_security_command_center: models.ProgressDetails;

    /**
     * Application of Governance Configurations current status
     */
    governance_configuration: models.ProgressDetailsForGovernanceConfiguration;

    /**
     * Validation of Governance Configurations current status
     */
    governance_configuration_validation: models.ProgressDetailsForGovernanceConfiguration;

    /**
     * Governance Report current status
     */
    governance_report: models.ProgressDetails;

    /**
     * Service Account Hierarchy current status
     */
    hierarchy_data: models.ProgressDetails;

    /**
     * Inventory Data current status
     */
    inventory_data: models.ProgressDetails;

    /**
     * Inventory Dashboard Data Sync current status
     */
    inventory_data__dashboard_sync: models.ProgressDetails;

    /**
     * Inventory Dependency Data Sync current status
     */
    inventory_data__dependency_sync: models.ProgressDetails;

    /**
     * Inventory Lock Data Sync current status
     */
    inventory_data__lock_sync: models.ProgressDetails;

    /**
     * Inventory Relationship Data Sync current status
     */
    inventory_data__relationship_sync: models.ProgressDetails;

    /**
     * Inventory Report current status
     */
    inventory_report: models.ProgressDetails;

    /**
     * Kubernetes Agent Sync Job Data current status
     */
    kubernetes_cluster_agent_sync_job: models.ProgressDetailsForKubernetesAgentSyncStatus;

    /**
     * Kubernetes Agent Health current status
     */
    kubernetes_cluster_agent_health: models.ProgressDetails;

    /**
     * Utilization Dashboard Metric Sync current status
     */
    metric_utilization_data: models.ProgressDetails;

    /**
     * Monthly Cost Report current status
     */
    monthly_cost_report: models.ProgressDetails;

    /**
     * Network Data current status
     */
    network_data: models.ProgressDetails;

    /**
     * ProActive Scanner current status
     */
    proactive_scanner: models.ProgressDetails;

    /**
     * Recovery Data current status
     */
    recovery_data: models.ProgressDetails;

    /**
     * Reserved Instance Recommendations current status
     */
    reserved_instances_recommendation: models.ProgressDetailsForReservedInstances;

    /**
     * Reserved Instance utilization current status
     */
    reserved_instances_utilization: models.ProgressDetailsForReservedInstances;

    /**
     * Secure Score Data current status
     */
    secure_score_data: models.ProgressDetailsForSecureScore;

    /**
     * Azure Sentinel Data Collection current status
     */
    security__azure_sentinel: models.ProgressDetails;

    /**
     * Tenable Nessus Vulnerability Data current status
     */
    security__tenable_nessus: models.ProgressDetails;

    /**
     * ServiceNow CMDB Sync Job Data current status
     */
    servicenow_cmdb_sync_job: models.ProgressDetailsForServiceNowCmdbSync;

    /**
     * System Policy Execution Data current status
     */
    system_policy_execution: models.ProgressDetails;

    /**
     * Threat Data current status
     */
    threat_data: models.ProgressDetailsForThreat;

    /**
     * Utilization Metrics Dashboard for Metric Sync current status
     */
    utilization_metrics_data: models.ProgressDetails;

    /**
     * Vulnerability Data current status
     */
    vulnerability_data: models.ProgressDetailsForVulnerability;

    /**
     * WellArchitected Auto Assessment Details current status
     */
    wellarchitected__auto_assessment: models.ProgressDetailsForWellArchitectedAutoAssessment;

}
